import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { HarnessIndexPage } from '@/components/harness/harness-runner';
import { HarnessCoveragePage } from '@/components/harness/harness-coverage-page';

export const harnessIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/harness',
  component: HarnessIndexPage,
});

export const harnessCoverageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/harness/$crawlId',
  component: HarnessCoverageRouteComponent,
});

function HarnessCoverageRouteComponent() {
  const { crawlId } = harnessCoverageRoute.useParams();
  return <HarnessCoveragePage crawlId={crawlId} />;
}
